import { defineRouting, replaceLocale } from "@trydig/next/i18n";
import { defineNavigation } from "@trydig/next/i18n/navigation";
import { addLeadingSlash, removeTrailingSlash } from "@trydig/utils";
import { getBaseUrl } from "@/lib/utils/getBaseUrl";
import { countryCodes } from "../../generated/countries";

export const LANGUAGES = ["en", "no"];
export const countries = countryCodes;

export const localesWithCountries = LANGUAGES.flatMap((locale) => {
	return countryCodes.map((country) => `${locale}-${country.country}`);
});

export const seoLocales = ["en-NO"];

export const routing = defineRouting({
	languages: LANGUAGES,
	defaultLocale: "en-NO",
	locales: localesWithCountries,
	localePrefix: "always",
	/**
	 * Sets the preferred countries when multiple countries are available for a language
	 */
	groups: ["categories", "products", "pages", "explore"],
	seoLocales,
	removeSegments: ["home", ...LANGUAGES],
});

export const {
	Link,
	Form,
	permanentRedirect,
	redirect,
	usePathname,
	useRouter,
	useGeo,
	SearchParamLink,
	addLocale,
} = defineNavigation(routing);

export const withDomain = (locale: string, uri: string) => {
	return removeTrailingSlash(
		`${getBaseUrl()}${addLeadingSlash(
			replaceLocale(uri, locale || routing.defaultLocale, routing),
		)}`,
	);
};

export const PRODUCT_URL_SEGMENT = "product";

export const productCanonicalPath = (uri: string) =>
	addLeadingSlash(`${PRODUCT_URL_SEGMENT}/${uri}`);
